import moment from 'moment'

export function showDate(dateAsString, dateShowFormat) {
  const d = new Date(dateAsString)
  moment.locale('ru')

  return moment(d).format(dateShowFormat)
}

export function showArticleEventDate(
  startEventDateAsString,
  eventDateAsString,
  eventDateTitle
) {
  const eventDate = new Date(eventDateAsString)
  moment.locale('ru')

  if (startEventDateAsString == null) {
    return moment(eventDate).format('D MMMM YYYY')
  } else {
    const startEventDate = new Date(startEventDateAsString)
    if (eventDate == startEventDate) {
      return moment(eventDate).format('D MMMM YYYY')
    } else {
      if (eventDateTitle == null || eventDateTitle == '') {
        if (startEventDate.getFullYear() == eventDate.getFullYear()) {
          if (startEventDate.getMonth() == eventDate.getMonth()) {
            return (
              moment(startEventDate).format('D') +
              ' ~ ' +
              moment(eventDate).format('D MMMM YYYY')
            )
          } else {
            return (
              moment(startEventDate).format('D MMMM') +
              ' ~ ' +
              moment(eventDate).format('D MMMM') +
              ' ' +
              moment(eventDate).format('YYYY')
            )
          }
        } else {
          return (
            moment(startEventDate).format('D MMMM YYYY') +
            ' ~ ' +
            moment(eventDate).format('D MMMM YYYY')
          )
        }
      } else {
        return eventDateTitle + ' ' + moment(eventDate).format('YYYY')
      }
    }
  }
}

export function declOfNum(number, titles) {
  var cases = [2, 0, 1, 1, 1, 2]
  return titles[
    number % 100 > 4 && number % 100 < 20
      ? 2
      : cases[number % 10 < 5 ? number % 10 : 5]
  ]
}

export function getRandomString(length) {
  var result = ''
  var characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  var charactersLength = characters.length
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

export function getFilenameAndExtension(pathfilename) {
  // eslint-disable-next-line no-useless-escape
  var filenameextension = pathfilename.replace(/^.*[\\\/]/, '')
  var filename = filenameextension.substring(
    0,
    filenameextension.lastIndexOf('.')
  )
  var ext = filenameextension.split('.').pop()

  return [filename, ext]
}

export function generateHashedIDs(id) {
  // Преобразуем ID в строку
  const idString = String(id);
  // Конкатенируем ID и соль
  const prefSalt = Array.from({length: 6}, () => Math.floor(Math.random() * 10)).join('')
  const suffSalt = Array.from({length: 4}, () => Math.floor(Math.random() * 10)).join('')
  const idWithSalt = prefSalt + idString + suffSalt;

  // Кодируем обрезанный хеш в Base64 и возвращаем результат
  return Buffer.from(idWithSalt).toString('base64');
}

export function decodeHashedIDs(encodedHash) {
  // Декодируем закодированный хеш из Base64
  const decodedHash = Buffer.from(encodedHash, 'base64').toString('ascii'); 
  console.log("decodedHash",decodedHash)
  return  decodedHash.slice(6,decodedHash.length-4)   
}
